import React from "react";
import asa from "../Images/asa1.jpg";
import asaBackground from "../Images/asabackground.png";

const ASASection = () => {
  return (
    <div className="bg-gray-50">

      {/* ================= HERO SECTION ================= */}

       <section
                    className="relative h-[420px] md:h-[500px] bg-cover bg-center"
                    style={{
                      backgroundImage: `url(${asaBackground})`, // Replace with your AutoCAD blueprint image later
                    }}
                  >
        {/* <div className="absolute inset-0 bg-slate-900/60"></div> */}

        <div className="relative z-10 h-full flex items-center">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 w-full">

            <div className="max-w-3xl">

              <div className="flex items-center gap-4 mb-6">
                <div className="w-20 h-[2px] bg-amber-500"></div>

                <span className="uppercase tracking-[5px] text-amber-400 font-semibold">
                  Our Services
                </span>
              </div>

              <h1 className="text-5xl lg:text-6xl font-bold text-slate-900 leading-tight">
                aSa Estimating
              </h1>

              <p className="mt-8 text-lg text-gray-600 leading-8">
                Industry-leading aSa Software solutions for accurate
                reinforcing steel estimation, material scheduling,
                quantity take-offs and project reporting.
              </p>

            </div>

          </div>
        </div>
      </section>

      {/* ================= SERVICES ================= */}

      <section className="py-24 bg-white">

        <div className="max-w-7xl mx-auto px-6 lg:px-8">

          <div className="grid lg:grid-cols-2 gap-16">

            {/* Card 1 */}

            <div className="bg-white rounded-3xl shadow-xl overflow-hidden hover:shadow-2xl transition">

              <img
                src={asa}
                alt="Structural Accuracy"
                className="w-full h-72 object-cover"
              />

              <div className="p-8">

                <h2 className="text-3xl font-bold text-slate-900 mb-5">
                  Structural Accuracy
                </h2>

                <p className="text-gray-600 leading-8">
                  aSa Software provides highly accurate reinforcing
                  steel estimation, structural calculations,
                  quantity take-offs and complete project analysis
                  for reinforced concrete structures.
                </p>

                <ul className="mt-8 space-y-4">

                  {[
                    "Accurate Quantity Take-offs",
                    "Structural Reinforcement Analysis",
                    "Material Optimization",
                    "Project Cost Estimation",
                    "Detailed Reports",
                  ].map((item, index) => (

                    <li
                      key={index}
                      className="flex items-center gap-3"
                    >

                      <span className="w-7 h-7 rounded-full bg-amber-100 text-amber-600 flex items-center justify-center font-bold">
                        ✓
                      </span>

                      {item}

                    </li>

                  ))}

                </ul>

              </div>

            </div>

            {/* Card 2 */}

            <div className="bg-white rounded-3xl shadow-xl overflow-hidden hover:shadow-2xl transition">

              <img
                src={asa}
                alt="Automated Scheduling"
                className="w-full h-72 object-cover"
              />

              <div className="p-8">

                <h2 className="text-3xl font-bold text-slate-900 mb-5">
                  Automated Scheduling
                </h2>

                <p className="text-gray-600 leading-8">
                  Automatically generate professional bar bending
                  schedules, reinforcement reports, material
                  summaries and fabrication documents while reducing
                  manual effort and errors.
                </p>

                <ul className="mt-8 space-y-4">

                  {[
                    "Bar Bending Schedule",
                    "Material Reports",
                    "Automatic Drawing Updates",
                    "Error-Free Documentation",
                    "Project Scheduling",
                  ].map((item, index) => (

                    <li
                      key={index}
                      className="flex items-center gap-3"
                    >

                      <span className="w-7 h-7 rounded-full bg-amber-100 text-amber-600 flex items-center justify-center font-bold">
                        ✓
                      </span>

                      {item}

                    </li>

                  ))}

                </ul>

              </div>

            </div>

          </div>

        </div>

      </section>

      {/* ================= BENEFITS ================= */}

      <section className="py-24 bg-gray-50">

        <div className="max-w-7xl mx-auto px-6">

          <div className="text-center mb-16">

            <span className="uppercase tracking-[5px] text-amber-500 font-semibold">
              Benefits
            </span>

            <h2 className="text-5xl font-bold text-slate-900 mt-4">
              Why aSa Software?
            </h2>

          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">

            {[
              {
                title: "High Accuracy",
                desc: "Industry-standard reinforcing steel estimation.",
              },
              {
                title: "Fast Processing",
                desc: "Complete projects in less time with automation.",
              },
              {
                title: "Automated Reports",
                desc: "Generate professional project reports instantly.",
              },
              {
                title: "Better Productivity",
                desc: "Reduce manual work and improve project efficiency.",
              },
            ].map((card, index) => (

              <div
                key={index}
                className="bg-white rounded-2xl p-8 shadow-lg hover:-translate-y-2 transition"
              >

                <div className="w-14 h-14 rounded-full bg-amber-100 text-amber-600 flex items-center justify-center text-2xl font-bold mb-6">
                  {index + 1}
                </div>

                <h3 className="text-2xl font-bold text-slate-900 mb-4">
                  {card.title}
                </h3>

                <p className="text-gray-600 leading-7">
                  {card.desc}
                </p>

              </div>

            ))}

          </div>

        </div>

      </section>

      {/* ================= CTA ================= */}

      

    </div>
  );
};

export default ASASection;